// SessionID yönetimi için utility fonksiyonları

const SESSION_STORAGE_KEY = 'bolpara_session_id';

/**
 * Unique bir sessionID oluşturur
 * @returns {string} UUID formatında sessionID
 */
export const generateSessionID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

/**
 * Mevcut sessionID'yi alır veya yoksa yeni bir tane oluşturur
 * @returns {string} SessionID
 */
export const getOrCreateSessionID = () => {
    let sessionID = sessionStorage.getItem(SESSION_STORAGE_KEY);
    
    if (!sessionID) {
        sessionID = generateSessionID();
        sessionStorage.setItem(SESSION_STORAGE_KEY, sessionID);
    }
    
    return sessionID;
};

/**
 * SessionID'yi temizler (logout veya session sıfırlama için)
 */
export const clearSessionID = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
};

/**
 * Mevcut sessionID'yi döndürür (yoksa null)
 * @returns {string|null} SessionID veya null
 */
export const getCurrentSessionID = () => {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
};

